module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-09.9b2ef003.png";